import { FC } from "react";
import { BrowserRouter } from "react-router-dom";
import { RecoilRoot } from "recoil";
import AppRoutes from "routes";

const App: FC = () => {
  return (
    <RecoilRoot>
      <BrowserRouter basename={process.env.PUBLIC_URL as string}>
        <AppRoutes />
      </BrowserRouter>
    </RecoilRoot>
  );
};

export default App;
